module.exports = __webpack_public_path__ + "img/icons_lined.5c969f42.svg";